//Пример в яндекс песочнице
//https://tech.yandex.ru/maps/jsbox/2.1/balloon_autopan

const schoolsMap = (id, lat, lon, file) => {
    if ( $('#'+id).length ) {

        const mapElement    = $('.js-map-element');
        const activeClass   = 'map-element--active';
        const markerDefault = 'assets/images/svg_icons/map-marker.svg';
        const markerActive  = 'assets/images/svg_icons/map-marker-active.svg';
        const pcCenter      = $('#'+id).attr('data-pc-center').split(',');
        const mobileCenter  = $('#'+id).attr('data-mobile-center').split(',');

        let mapCenter = pcCenter;

        if ($(window).width() <= APP.tabletXsWidth ) {
            mapCenter = mobileCenter;
        }

        mapElementsHandler(1);
        ymaps.ready(function () {
            let map = new ymaps.Map(id, {
                    center: mapCenter,
                    zoom: 11,
                    controls: []
                }),
                balloonLayout = ymaps.templateLayoutFactory.createClass(
                    '<div class="map-popup">' +
                        '<button type="button" class="map-popup__close js-close-popup"><svg class="i"><use xlink:href="#close-modal"/></svg></button>' +
                            '<div class="map-popup__arrow"></div>' +
                            '<div class="map-popup__inside">' +
                            '$[[options.contentLayout observeSize]]' +
                        '</div">' +
                    '</div>', {
                        /**
                         * Строит экземпляр макета на основе шаблона и добавляет его в родительский HTML-элемент.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#build
                         * @function
                         * @name build
                         */
                        build: function () {
                            this.constructor.superclass.build.call(this);
                            this._$element = $('.map-popup', this.getParentElement());
                            this.applyElementOffset();
                            this._$element.find('.js-close-popup')
                                .on('click', $.proxy(this.onCloseClick, this));
                        },

                        /**
                         * Удаляет содержимое макета из DOM.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/layout.templateBased.Base.xml#clear
                         * @function
                         * @name clear
                         */
                        clear: function () {
                            this._$element.find('.js-close-popup')
                                .off('click');

                            this.constructor.superclass.clear.call(this);
                        },
                        /**
                         * Метод будет вызван системой шаблонов АПИ при изменении размеров вложенного макета.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                         * @function
                         * @name onSublayoutSizeChange
                         */
                        onSublayoutSizeChange: function () {
                            balloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                            if(!this._isElement(this._$element)) {
                                return;
                            }

                            this.applyElementOffset();

                            this.events.fire('shapechange');
                        },

                        /**
                         * Сдвигаем балун, чтобы "хвостик" указывал на точку привязки.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                         * @function
                         * @name applyElementOffset
                         */
                        applyElementOffset: function () {

                            this._$element.css({
                                top: -(this._$element[0].offsetHeight/2 + 19)
                            });
                        },

                        /**
                         * Закрывает балун при клике на крестик, кидая событие "userclose" на макете.
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/IBalloonLayout.xml#event-userclose
                         * @function
                         * @name onCloseClick
                         */
                        onCloseClick: function (e) {
                            e.preventDefault();

                            this.events.fire('userclose');
                        },

                        /**
                         * Используется для автопозиционирования (balloonAutoPan).
                         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ILayout.xml#getClientBounds
                         * @function
                         * @name getClientBounds
                         * @returns {Number[][]} Координаты левого верхнего и правого нижнего углов шаблона относительно точки привязки.
                         */
                        getShape: function () {
                            if(!this._isElement(this._$element)) {
                                return balloonLayout.superclass.getShape.call(this);
                            }

                            var position = this._$element.position();

                            return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                                [position.left, position.top], [
                                    position.left + this._$element[0].offsetWidth,
                                    position.top + this._$element[0].offsetHeight + this._$element.find('.map-popup__arrow')[0].offsetHeight
                                ]
                            ]));
                        },

                        /**
                         * Проверяем наличие элемента (в ИЕ и Опере его еще может не быть).
                         * @function
                         * @private
                         * @name _isElement
                         * @param {jQuery} [element] Элемент.
                         * @returns {Boolean} Флаг наличия.
                         */
                        _isElement: function (element) {
                            return element && element[0] && element.find('.map-popup__arrow')[0];
                        }
                    }),

                // Создание вложенного макета содержимого балуна.
                balloonLayoutContent = ymaps.templateLayoutFactory.createClass(
                    '<h5 class="map-popup__heading">$[properties.balloonHeader]</h5>' +
                    '<p class="map-popup__text">$[properties.balloonMetro]</p>' +
                    '<p class="map-popup__text">$[properties.balloonAddress]</p>' +
                    '<p class="map-popup__text"><a href="tel:$[properties.balloonPhone]">$[properties.balloonPhone]</a></p>' +
                    '<p class="map-popup__text"><a href="mailto:$[properties.balloonEmail]">$[properties.balloonEmail]</a></p>' +
                    '<div class="map-popup__control"><a class="button button--bordered-grey" target="_blank" href="https://$[properties.balloonButton]">Перейти к отделению</a></div>'
                );

            let zoomControls = ymaps.templateLayoutFactory.createClass(
                "", {
                        build: function () {
                            zoomControls.superclass.build.call(this);
                            this.zoomInCallback = ymaps.util.bind(this.zoomIn, this);
                            this.zoomOutCallback = ymaps.util.bind(this.zoomOut, this);
                            $('#zoom-in').bind('click', this.zoomInCallback);
                            $('#zoom-out').bind('click', this.zoomOutCallback);
                            $('#geo').bind('click', this.geo);
                        },
                        clear: function () {
                            $('#zoom-in').unbind('click', this.zoomInCallback);
                            $('#zoom-out').unbind('click', this.zoomOutCallback);
                            zoomControls.superclass.clear.call(this);
                        },
                        zoomIn: function () {
                            var map = this.getData().control.getMap();
                            map.setZoom(map.getZoom() + 1, {checkZoomRange: true});
                        },
                        zoomOut: function () {
                            var map = this.getData().control.getMap();
                            map.setZoom(map.getZoom() - 1, {checkZoomRange: true});
                        },
                        geo: function() {
                            ymaps.geolocation
                                .get({
                                    provider           : 'yandex',
                                    mapStateAutoApply  : true,
                                    autoReverseGeocode : false
                                })
                                .then(function (result) {
                                    map.geoObjects.add(result.geoObjects);
                                });
                        }
                    }),
                zoomControl = new ymaps.control.ZoomControl({options: {layout: zoomControls}});
                map.controls.add(zoomControl, {position: {right: '20px', top: '0', height: '100%'}});


            map.behaviors.disable('scrollZoom');

            $.ajax({
                url: file
            }).done(function(data) {
                $.each(data['elements'], function(i, element){
                    // Создание метки с пользовательским макетом балуна.
                    const placemark = new ymaps.Placemark(element.coordinates, {},{
                        hideIconOnBalloonOpen: false,
                        iconLayout: 'default#image',
                        iconImageHref: markerDefault,
                        iconImageSize: [31, 45],
                        iconImageOffset: [-15, -40]
                    });

                    /*objectManager.objects.options.set('preset', 'islands#grayIcon');
                    objectManager.add({
                        type: 'Feature',
                        id: i,
                        geometry: {
                            type: 'Point',
                            coordinates: element.coordinates
                        },
                        properties: {}
                    });*/

                    map.geoObjects.add(placemark);

                    placemark.events.add('click', function(e) {
                        mapElement.removeClass(activeClass);
                        $('#js-map-element-'+i).addClass(activeClass);

                        mapElementScrollHandler(i);
                        changeMapLocation(map, element.coordinates);
                    });

                    //toggle element
                    //removed on the 22.10.19
                    /*$('#js-map-element-'+i).on('click', function(){
                        mapElement.removeClass(activeClass);

                        if ( !$(this).hasClass(activeClass) ) {
                            $(this).addClass(activeClass);

                            changeMapLocation(map, element.coordinates);
                        }
                    });*/
                });
            });

            //change city
            const mapSelect = $('.js-map-select');
            mapSelect.on('change', function(){
                const val = $(this).val();

                if ( !val || val == 0 ) return false;

                const option  = $(this).find('[value="'+ val +'"]');
                const lat     = parseFloat(option.attr('data-lat'));
                const lon     = parseFloat(option.attr('data-lon'));
                const cityID  = parseFloat(option.attr('data-id'));

                changeMapLocation(map, [lat, lon]);
                mapElementsHandler(cityID);
            });
        });
    }
}
const changeMapLocation = (map, coords) => {
    map.panTo(coords, {
        flying: 1
    });
}
const mapElementsHandler = (id) => {
    const element   = $('.js-map-element');

    element.hide();
    $('[data-map-element="'+ id +'"]').fadeIn(100);
    window.scrollbars.update();
}
const mapElementScrollHandler = (id) => {
    const element = $('#js-map-element-'+id);

    if ( element.length ) {
        const container = element.parents('.js-scrollable-block');
        const containerTop = container.scrollTop();
        const position  = element.position().top;

        container.animate({scrollTop: position + containerTop}, 500);
    }
}